import { IAlbum } from "../../common/Album";

const album: IAlbum = {
  title: "Wardrobe Malfunction",
  date: new Date(2024, 7, 11),
  img: "/img/kings.jpeg",
  video: "/videos/kings.mp4",
  tracks: [
    {
      title: "Felt Slippers",
      src: "/songs/2024-08-11/felt_slippers.mp3",
      duration: 719.376,
    },
    {
      title: "Smoking Robe",
      src: "/songs/2024-08-11/smoking_robe.mp3",
      duration: 996.792,
    },
    {
      title: "(Slipping Into) Something A Little More Comfortable",
      src: "/songs/2024-08-11/something_a_little_more_comfortable.mp3",
      duration: 1106.088,
    },
    {
      title: "Dressed For Success",
      src: "/songs/2024-08-11/dressed_for_success.mp3",
      duration: 917.04,
    },
    {
      title: "Business Casual",
      src: "/songs/2024-08-11/business_casual.mp3",
      duration: 860.952,
    },
    {
      title: "Phresh Britches",
      src: "/songs/2024-08-11/phresh_britches.mp3",
      duration: 765.336,
    },
    {
      title: "Silky Lingerie",
      src: "/songs/2024-08-11/silky_lingerie.mp3",
      duration: 1344.744,
    },
    {
      title: "The King (Wears No Clothes)",
      src: "/songs/2024-08-11/the_king_wears_no_clothes.mp3",
      duration: 2760.72,
    },
  ],
};
export default album;
